// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"4f4a0941","626":"4f4a0941","780":"4f4a0941","798":"4f4a0941"}[chunkId] + ".chunk.css";
};